import * as React from "react";
import { clsx } from "@plans/appkit";
import { AlertTriangleIcon } from "@plans/icons/untitled-ui/AlertTriangleIcon";
import { InfoCircleIcon } from "@plans/icons/untitled-ui/InfoCircleIcon";
import { ClickableTooltip } from "~/components/molecules/ClickableTooltip";

type InfoTooltipWithContentProps = {
	content: React.ReactNode;
	dangerouslySetContentInnerHTML?: never;
	className?: string;
	contentClassName?: string;
	type?: "info" | "warning";
	iconClassName?: string;
	delayDuration?: number;
	onClick?: (event: React.MouseEvent<HTMLElement>) => void;
};

type InfoTooltipWithDangerouslySetInnerHTMLProps = {
	dangerouslySetContentInnerHTML: {
		__html: string | TrustedHTML;
	};
	type?: "info" | "warning";
	content?: never;
	className?: string;
	contentClassName?: string;
	iconClassName?: string;
	delayDuration?: number;
	onClick?: (event: React.MouseEvent<HTMLElement>) => void;
};

type InfoTooltipProps =
	| InfoTooltipWithContentProps
	| InfoTooltipWithDangerouslySetInnerHTMLProps;

export function InfoTooltip({
	content,
	className,
	contentClassName,
	dangerouslySetContentInnerHTML,
	type = "info",
	iconClassName,
	delayDuration,
	onClick,
}: InfoTooltipProps) {
	const contentProps = dangerouslySetContentInnerHTML
		? { dangerouslySetInnerHTML: dangerouslySetContentInnerHTML }
		: { children: content };
	return (
		<ClickableTooltip
			onClick={onClick}
			delayDuration={delayDuration}
			contentClassName={contentClassName}
			trigger={
				<span
					className={clsx(
						"-my-[0.08em] mx-[0.35em] inline-block cursor-pointer align-middle text-current",
						className,
					)}
				>
					{type === "info" && (
						<InfoCircleIcon
							className={clsx(
								"h-[1.14285714em] w-[1.14285714em] -translate-y-[0.075em] opacity-35 hover:opacity-80",
								iconClassName,
							)}
						/>
					)}
					{type === "warning" && (
						<AlertTriangleIcon
							className={clsx(
								"text-accent-warning h-[1.06666667em] w-[1.06666667em]",
								iconClassName,
							)}
						/>
					)}
				</span>
			}
		>
			<span {...contentProps} />
		</ClickableTooltip>
	);
}
